import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "ProductSlider",
    component: () => (__SERVER__ ? require("./product-slider-view") : import("./product-slider-view"))
});

export default definition;
